import { Card } from "react-bootstrap";
import { MinusCircle, PlusCircle } from "react-feather";
import EmptyFilter from "./empty-filter";
import IncludeExcludeFilter from "./includeExcludeFilter";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LoaderImg from "@assets/images/loader.gif";
import Select from "react-select";

const categoryStyles = {
  control: (base) => ({
    ...base,
    height: 36,
    minHeight: 36,
    backgroundColor: "#fafafa",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: 500,
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    fontWeight: 500,
    padding: "8px",
  }),
  option: (base, { isDisabled, isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isDisabled ? null : isSelected ? "rgba(111, 8, 241, 0.1)" : isFocused ? "rgba(111, 8, 241, 0.1)" : null,
    color: isDisabled ? null : isSelected ? "#1a1722" : isFocused ? "#1a1722" : null,
    cursor: "pointer !important",
    marginBottom: "8px",
  }),
};

const RangeMultiSelect = ({ heading, closeFilter, filterList, appliedFilterList, filterKeyword, onSelect, emptyContent, placeholder, includeFilter, excludeFilter, showIncludeExclude }) => {
  const [filterData, setFilterData] = useState([]);
  const [rows, setRows] = useState([{ id: 1, dropdown: null, input1: null, input2: null }]);
  const [availableOptions, setAvailableOptions] = useState([]);
  const [includeFilterButton, setIncludeFilterButton] = useState("true");
  const [error, setError] = useState("");

  useEffect(() => {
    let initialOptions = [];
    for (let i = 0; i < filterData.length; i++) {
      initialOptions.push({
        label: filterData[i].key,
        value: filterData[i].key,
        range: filterData[i].range,
      });
    }
    setAvailableOptions(initialOptions);
    if (appliedFilterList && appliedFilterList.length > 0) {
      let tempRows = [];
      let availableOptionsClone = JSON.parse(JSON.stringify(initialOptions));
      for (let i = 0; i < appliedFilterList.length; i++) {
        let tempAppliedFilter = appliedFilterList[i];
        availableOptionsClone = availableOptionsClone.filter((item) => item.value !== tempAppliedFilter.key);
        tempRows.push({
          id: i + 1,
          input1: tempAppliedFilter.range?.[0],
          input2: tempAppliedFilter.range?.[1],
          dropdown: initialOptions.find((item) => item.value === tempAppliedFilter.key),
        });
      }
      setAvailableOptions(availableOptionsClone);
      setRows(tempRows);
    }
  }, [filterData]);

  useEffect(() => {
    if (includeFilter.includes(filterKeyword)) {
      setIncludeFilterButton("true");
    } else if (excludeFilter.includes(filterKeyword)) {
      setIncludeFilterButton("false");
    }
  }, []);

  const filterLoader = useSelector((state) => state.shipmentDetails.filterLoader);

  useEffect(() => {
    setFilterData(filterList ? filterList : []);
  }, [filterList]);

  const handleChange = (id, field, value, minMaxValue) => {
    let tempError = { ...error };
    setRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id === id) {
          if (field === "dropdown") {
            setAvailableOptions((prev) => {
              const newOptions = [...prev];
              if (row.dropdown) {
                newOptions.push(row.dropdown);
              }
              return newOptions.filter((option) => option.value !== value.value);
            });
            row.input1 = null;
            row.input2 = null;
          }
          if (field === "input1") {
            if (value < minMaxValue.range[0] || value === "") {
              tempError[row.id] = "Input Value Cannot be less than " + minMaxValue.range[0];
            } else if (row.input2 > row.dropdown.range[1]) {
              tempError[row.id] = "Input Value Cannot be greater than " + row.dropdown.range[1];
            } else tempError[row.id] = "";
          } else if (field === "input2") {
            if (value > minMaxValue.range[1] || value === "") {
              tempError[row.id] = "Input Value Cannot be greater than " + minMaxValue.range[1];
            } else if (row.input1 < row.dropdown.range[0]) {
              tempError[row.id] = "Input Value Cannot be less than " + row.dropdown.range[0];
            } else tempError[row.id] = "";
          }
          setError(tempError);
          return { ...row, [field]: value };
        }
        return row;
      })
    );
  };

  const addRow = () => {
    const newId = rows.length > 0 ? Math.max(...rows.map((r) => r.id)) + 1 : 1;
    setRows([...rows, { id: newId, dropdown: null, input1: null, input2: null }]);
  };

  const removeRow = (id) => {
    setRows((prevRows) => {
      const removedRow = prevRows.find((row) => row.id === id);
      if (removedRow && removedRow.dropdown) {
        setAvailableOptions((prev) => [...prev, removedRow.dropdown]);
      }
      return prevRows.filter((row) => row.id !== id);
    });
  };

  const checkError = (row) => {
    if (row.input2 && row.input1 && +row.input2 < +row.input1) {
      return true;
    }
    if (row.input2 === null && row.input1 !== null && row.dropdown && +row.dropdown.range[1] < +row.input1) {
      return true;
    }
    if (row.input1 === null && row.input2 !== null && row.dropdown && +row.dropdown.range[0] > +row.input2) {
      return true;
    }
    if (row.input1 === null && row.input2 === null && row.dropdown && +row.dropdown.range[0] > +row.dropdown.range[1]) {
      return true;
    }
    return false;
  };

  const checkDisable = () => {
    if (rows.length > 0) {
      for (let i = 0; i < rows.length; i++) {
        if (checkError(rows[i]) || !Object.keys(error).every((key) => error[key] === "") || rows.every((row) => row.dropdown === null)) {
          return true;
        }
      }
      return false;
    } else return true;
  };

  return (
    <Card className="view-all-filter-panel-card" onClick={(e) => e.stopPropagation()}>
      <Card.Header>
        <div className="d-flex">
          <div className="col-md-5 pl-0">
            <h5 className="modal_header ml-3">{heading ? heading : placeholder}</h5>
          </div>
          <div className="col-md-3 pl-0" />
          <div className="col-md-4 text-right pr-0 d-flex justify-content-end">
            <button type="button" className="btn btn-primary btn-sm trademo-new-btn" disabled={checkDisable()} onClick={() => onSelect(rows, includeFilterButton)}>
              Apply Filter
            </button>
            <button type="button" className="close trademo-modal-close" aria-label="Close" onClick={() => closeFilter(filterKeyword)}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="pt-0">
        <div className={`mb-3 viewall-sticky-header pt-2`}>{showIncludeExclude ? <IncludeExcludeFilter includeFilter={includeFilter.includes(filterKeyword)} excludeFilter={excludeFilter.includes(filterKeyword)} setIncludeFilter={(data) => setIncludeFilterButton(data)} /> : null}</div>
        {filterLoader ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "calc(100% - 146px)" }}>
            <img src={LoaderImg} alt="description of gif" />
          </div>
        ) : filterData?.length !== 0 ? (
          <div>
            {rows.map((row, index) => (
              <div key={row.id} className="d-flex flex-wrap align-items-center range-view-all-card h-100 my-3">
                <div className="col-md-4 d-flex align-items-center text-no-transform">
                  <div className="label-sm-regular text-no-transform text-nowrap mr-3">Select quantity unit</div>
                  <Select className="match-type w-100" placeholder="Select Quantity" options={availableOptions} styles={categoryStyles} onChange={(value) => handleChange(row.id, "dropdown", value)} value={row.dropdown} />
                </div>
                <div className="col-md-3">
                  <div className="px-0 d-flex align-items-center">
                    <div className="range-label text-nowrap mr-3">Minimum range</div>
                    <input className="box label-styling range-input" value={row?.input1 !== null ? row?.input1 : row?.dropdown?.range?.[0]} disabled={row.dropdown === null} type="number" onChange={(e) => handleChange(row.id, "input1", e.target.value, row.dropdown)} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="px-0 d-flex align-items-center">
                    <div className="range-label text-nowrap mr-3">Maximum range</div>
                    <input className="box label-styling range-input" value={row?.input2 !== null ? row?.input2 : row?.dropdown?.range?.[1]} disabled={row.dropdown === null} type="number" onChange={(e) => handleChange(row.id, "input2", e.target.value, row.dropdown)} />
                  </div>
                </div>
                <div className="col-md-1 d-flex align-items-center justify-content-start">
                  <div>{((rows?.length > 1 && index !== rows?.length - 1) || (index > 0 && row?.dropdown !== null)) && <MinusCircle size={24} color="#667085" onClick={() => removeRow(row.id)} className="cursor-pointer" />}</div>
                  <div>{!(rows?.length > 1 && index !== rows?.length - 1) && <PlusCircle size={24} color="#667085" onClick={addRow} className="cursor-pointer" />}</div>
                </div>
                {error[row.id] && <div className="text-danger my-2 label-sm-medium text-capitalize col-md-12">{error[row.id]}</div>}
                {checkError(row) ? <div className="text-danger my-2 label-sm-medium text-capitalize col-md-12">Maximum range should be greater than minimum range</div> : ""}
              </div>
            ))}
          </div>
        ) : (
          <EmptyFilter content={emptyContent ? emptyContent : ""} />
        )}
      </Card.Body>
    </Card>
  );
};

export default RangeMultiSelect;
